"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _NoOptionsMessage = require("./NoOptionsMessage");

var _default = _NoOptionsMessage.NoOptionsMessage;
exports["default"] = _default;